import { render, staticRenderFns } from "./role-pane.vue?vue&type=template&id=08569e67&scoped=true"
import script from "./role-pane.vue?vue&type=script&lang=js"
export * from "./role-pane.vue?vue&type=script&lang=js"
import style0 from "./role-pane.vue?vue&type=style&index=0&id=08569e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08569e67",
  null
  
)

export default component.exports